import { useContext } from 'react';
import { useExportJobsCSV } from 'src/queries/ExportRequest';
import { useFilters } from 'src/react/_routes/JobListing/FilterMenu/_hooks/useFilters';
import { EXPORT_REQUEST_KEY, ExportRequestContext } from '../Context/ExportRequest/context';

const useBuildFilterParams = () => {
  const { appliedFilters } = useFilters();

  if (!appliedFilters.size) return undefined;

  const params = new URLSearchParams(appliedFilters);

  return params;
};

export const useGenerateJobsCSV = () => {
  const { setExportRequestKey, setIsExportFailed, setIsConcurrencyError } = useContext(ExportRequestContext);

  const jobsTotalEntries = 0;

  const filterParams = useBuildFilterParams();

  const {
    mutateAsync: exportJobsCSV,
    isPending: isInitiatingExport,
    ...params
  } = useExportJobsCSV({
    onSuccess: ({ exportRequest: { key } }) => {
      setExportRequestKey(key);
      setIsExportFailed(false);
      setIsConcurrencyError(false);
      localStorage.setItem(EXPORT_REQUEST_KEY, key);
    },
    onError: ({ isConcurrencyError }) => {
      setIsConcurrencyError(isConcurrencyError);
      setIsExportFailed(true);
      setExportRequestKey(null);
      localStorage.removeItem(EXPORT_REQUEST_KEY);
    },
  });

  return {
    exportJobsCSV: () =>
      exportJobsCSV({
        filterParams,
        expectedRows: jobsTotalEntries,
      }),
    isInitiatingExport,
    ...params,
  };
};
